import { Spin } from "antd";
import { FontFa } from "../../../../../components";
import { getRandomColor } from "../../../../../helper/util";
import { usePublicDocumentContent } from "../../../hooks/published-documents/use-public-document-content";

export const HistoryVersionListItem = ({ version }: { version: number }) => {
  const { isLoading, docPublicData } = usePublicDocumentContent();

  if (isLoading) return <Spin />;

  return (
    <div className="d-flex flex-column ml-2">
      {/* <h5>{DateHelper.formatDateToString(item.Modified, { format: DateFormat.DD_MM_YYYY_HH_MM })}</h5> */}
      <span style={{ fontStyle: "italic", padding: 0 }}>{`Phiên bản ${version}`}</span>
      <span>
        <FontFa name="faDotCircle" color={getRandomColor(docPublicData?.userDisplayName || "")} /> {docPublicData?.userDisplayName}
      </span>
    </div>
  );
};
